import { ViewFactory } from 'wdc-cube-react'
import GrupoScope, { HeaderScope } from '../grupo.scopes'
import GrupoView from './grupo.view'
import HeaderView from './grupo.header'

export function registerViews(rv = ViewFactory.register) {
    rv(GrupoScope, GrupoView)
    rv(HeaderScope, HeaderView)
}
